export const getHref = (name?: string) => (name ? `${process.env.NX_PUBLIC_CLOUD_PAYSEND_API}/consumer3/svg/${name}.svg#symb` : undefined);

// Holds a strong reference to every preloaded icon: a garbage-collected Image can have its in-flight request dropped.
const preloadedIcons = new Map<string, HTMLImageElement>();

/**
 * Warms the browser HTTP cache with an icon so it still renders when the network is gone.
 * Loads the exact URL CoreImageView uses, so the cached entry is reused as-is (no fetch/Cache API involved).
 * A failed attempt is forgotten so a later call can retry it.
 *
 * @param name icon name as passed to getHref (e.g. 'ic_alert_circle_small')
 */
export const preloadIcon = (name?: string) => {
    const href = getHref(name);
    if (!href || typeof window === 'undefined' || preloadedIcons.has(href)) {
        return;
    }
    const image = new window.Image();
    preloadedIcons.set(href, image);
    image.onerror = () => preloadedIcons.delete(href);
    image.src = href;
};
